import React from 'react';
import { Server } from '../../server/server';
import { getBannerImage, getPortraitImage } from '../util/user';
import { BsCalendarWeek, BsChatDotsFill, BsFillEyeFill, BsFillEyeSlashFill, BsFillPersonPlusFill, BsPencilFill } from 'react-icons/bs';
import MessageModal from '../modals/MessageModal';
import AlertModal from '../modals/AlertModal';
import { NavLink, Navigate } from 'react-router-dom';
import QuestionModal from '../modals/QuestionModal';
import EditProfileModal from '../modals/EditProfileModal';
import BlogCard from '../elements/BlogCard';
import { WithRouterProps } from '../util/withRouter';
import ContentPanel from '../elements/ContentPanel';
import ActivityButtons from '../elements/ActivityButtons';
import PageEnvelope from '../elements/PageEnvelope';
import './SitePage.css'

interface ProfilePageProps {
  router: WithRouterProps;
}

interface ProfilePageState {
  profile: any;
  profileError: string;
  followers: any[];
  following: any[];
  message: string;
  alert: string;
  question: string;
  navigate: string;
  openEditProfile: boolean;
  blogs: any[];
  posts: any[];
  loading: boolean;
  loadingMore: boolean;
  filter: string;
}

class ProfilePage extends React.Component<ProfilePageProps, ProfilePageState> {
  author = '';
  posLodMore = 0;
  isActivity = true;

  constructor(props: ProfilePageProps) {
    super(props);

    this.state = {
      profile: null,
      profileError: '',
      followers: [],
      following: [],
      message: '',
      alert: '',
      question: '',
      navigate: '',
      openEditProfile: false,
      blogs: [],
      posts: [],
      loading: false,
      loadingMore: false,
      filter: 'activity'
    };

    this.onFriendUpdated = this.onFriendUpdated.bind(this);
    this.onSendMessage = this.onSendMessage.bind(this);
    this.onQuestionYes = this.onQuestionYes.bind(this);
    this.onQuestionNo = this.onQuestionNo.bind(this);
    this.openEditProfile = this.openEditProfile.bind(this);
    this.onCloseEditProfile = this.onCloseEditProfile.bind(this);
    this.onBlogClick = this.onBlogClick.bind(this);
    this.onBlogEdit = this.onBlogEdit.bind(this);
  }

  componentDidMount() {
    let filter = sessionStorage.getItem('profile-filter');
    this.isActivity = filter ? JSON.parse(filter) : true;

    this.loadProfile();
    Server.user.addEventListener('friend-updated', this.onFriendUpdated);
  }
    
  componentDidUpdate(prevProps: Readonly<ProfilePageProps>) {
    if(prevProps.router.location.pathname != this.props.router.location.pathname) 
      this.loadProfile();
  }
  
  componentWillUnmount() {
    Server.user.removeEventListener('friend-updated', this.onFriendUpdated);
  }

  async getBlogs(params: any) {
    if (this.state.blogs.length == 0)
      this.setState({loading: true});

    let response = await Server.blogs.getBlogs(params);
    if (!response.success)
      return

    let blogs = response.blogs;
    if (this.state.loadingMore)
      blogs = this.state.blogs.concat(blogs);

    this.setState({blogs: blogs, loading: false, loadingMore: false});

    setTimeout(() => {
      let div = document.getElementById('id-app-page');
      div.scrollTo(0, this.posLodMore);
    }, 10);
  }

  onBlogClick(blog:any) {
    // this.saveState();
    this.setState({navigate: '/blog/' + blog.slug})
  }

  onBlogEdit(blog:any) {
    // this.saveState();
    this.setState({navigate: '/blog/edit/' + blog.slug})
  }

  async getPosts(params: any) {
    if (this.state.posts.length == 0)
      this.setState({loading: true});

    let response = await Server.activity.getPosts(params);
    if (!response.success)
      return

    // cache profiles
    let profiles = [];
    let posts = response.posts;

    for (let i = 0; i < posts.length; i++) {
      if (posts[i].repost)
        if(profiles.indexOf(posts[i].repost.author) == -1)
          profiles.push(posts[i].repost.author);
    }

    await Server.public.loadProfiles(profiles);

    if (this.state.loadingMore)
      posts = this.state.posts.concat(posts);

    this.setState({posts: posts, loading: false, loadingMore: false});

    setTimeout(() => {
      let div = document.getElementById('id-app-page');
      div.scrollTo(0, this.posLodMore);
    }, 10);
  }

  onFriendUpdated(event:any) {
    this.forceUpdate();
  }

  async loadProfile() {
    let profile = Server.public.getProfile(Server.user.getId());

    if(this.props.router.params.id) {
      let slug = this.props.router.params.id;
      let response = await Server.public.loadProfileFromSlug(slug);
      if(!response.success) {
        this.setState({profile: null, profileError: response.message});
        return;
      }
      profile = response.profile;
    }

    if(this.state.filter == 'activity')
      this.getPosts({author: profile.id});
    else
      this.getBlogs({author: profile.id});

    this.setState({profile});
  }

  onSendMessage() {
    let chat = Server.messages.getChat(this.state.profile.id);

    if(chat) {
      window.sessionStorage.setItem('ChatPageId', chat.id);
      this.setState({navigate: '/chat'});
      return;
    }

    this.setState({message: 'Starting chat...'});

    setTimeout(async () => {
      let response = await Server.messages.startDirectChat(this.state.profile.id);

      if(response.success) {
        chat = Server.messages.getChat(this.state.profile.id);
        window.sessionStorage.setItem('ChatPageId', chat.id);
        this.setState({navigate: '/chat'});
      }
      else {
        this.setState({alert: response.message, message: ''})
      }
    }, 500);
  }

  onGift() {
    this.setState({navigate: '/storage'});
  }

  async onFollow() {
    if(!Server.account.isLoggedIn()) {
      this.setState({alert: 'Please login to follow this users activity.'});
      return;
    }

    let isFollowing = Server.user.isFollowing(this.state.profile.id);
    let response:any = null;
    if (isFollowing) {
      this.setState({ message: 'Unfollowing...' });
      response = await Server.user.unfollow(this.state.profile.id);
    }
    else {
      this.setState({ message: 'Following...' });
      response = await Server.user.follow(this.state.profile.id);
    }

    setTimeout(() => {
    
      if (response.success) {
        this.setState({message: ''});
      }
      else 
        this.setState({message: ''});
    }, 500);
  }

  async onInvite() {
    if(!Server.account.isLoggedIn()) {
      this.setState({alert: 'Please login to invite this user to be your friend.'});
      return;
    }

    let friend = Server.user.getFriend(this.state.profile.id);
    if(!friend)
      this.setState({question: `Invite ${this.state.profile.name} to be your friend?`});
    else
      this.setState({alert: `You have already sent ${this.state.profile.name} an invite.`})
  }

  onQuestionYes() {
    this.setState({question: '', message: 'Sending invite...'});
    setTimeout(async () => {
      await Server.user.inviteFriendBySlug(this.state.profile.slug);
      this.setState({message: '', alert: `Invite sent!`});
    }, 500);
  }

  onQuestionNo() {
    this.setState({question: ''});
  }

  openEditProfile() {
    this.setState({openEditProfile: true});
  }

  async onCloseEditProfile() {
    let profile = Server.user.getProfile();
    Server.public.addProfileToCache(profile);
    this.setState({profile, openEditProfile: false});
  }

  renderActionButtons() {
    if(this.state.profile.slug == Server.user.getSlug()) {
      return (
        <div className="site-page-row" style={{justifyContent: 'right'}}>
          <button onClick={this.openEditProfile} className="site-page-icon-button">
            <BsPencilFill />
          </button>
        </div>      
      )
    }

    let isFriend = Server.account.isLoggedIn() && Server.user.isFriend(this.state.profile.id);
    let isFollowing = Server.account.isLoggedIn() && Server.user.isFollowing(this.state.profile.id);

    return (
      <div className="site-page-row" style={{justifyContent: 'right'}}>
        {isFriend &&
          <button className="site-page-icon-button" onClick={this.onSendMessage}><BsChatDotsFill size="1.2em"/></button>
        }

        {/* {isFriend && 
          <button className="site-page-icon-button" onClick={()=>this.onGift()}><BsGiftFill/></button>
        } */}

        {!isFriend &&   
          <button className="site-page-icon-button" onClick={() => this.onInvite()}><BsFillPersonPlusFill size="1.2em"/></button>
        }

        {!isFriend && !isFollowing &&  
          <button className="site-page-icon-button" onClick={() => this.onFollow()}><BsFillEyeFill size="1.2em"/></button>
        }

        {!isFriend && isFollowing && 
          <button className="site-page-icon-button" onClick={() => this.onFollow()}><BsFillEyeSlashFill size="1.2em"/></button>
        }
      </div>
    )
  }

  onFilter(filter: string) {
    this.posLodMore = 0;

    this.setState({filter});

    // sessionStorage.setItem('profile-filter', this.isActivity.toString());

    if (filter == 'activity') {
      this.setState({posts: []});
      setTimeout(() => {
        this.getPosts({author: this.state.profile.id});
      }, 10);
    }
    else {
      this.setState({blogs: []});
      setTimeout(() => {
        this.getBlogs({author: this.state.profile.id});
      }, 10);
    }
  }

  onLoadMore() {
    if(!Server.account.isLoggedIn()) {
      this.setState({alert: 'Please login to view more community activity.'});
      return;
    }

    let data  = this.isActivity ? this.state.posts : this.state.blogs;
    let index = data.length - 1;
    let id    = data[index].id;
    let date  = data[index].date;

    let params = {
      author: this.state.profile.id,
      before: {date, id}
    }

    if (this.isActivity) 
      this.getPosts(params);
    else 
      this.getBlogs(params);

    let div = document.getElementById('id-app-page');
    this.posLodMore = div.scrollTop;
    this.setState({ loadingMore: true })
  }

  renderLoadMoreButton() {
    return (
      <div style={{marginTop: '5px'}}>
        <button 
          onClick={()=>this.onLoadMore()} 
          disabled={this.state.loadingMore ? true : false}
        >
          {this.state.loadingMore ? 'Loading...' : 'Load More'}
        </button>
      </div>
    )
  }

  onPostClick(id:string) {
    this.setState({navigate: "/activity/post/" + id});    
  }

  renderPosts() {
    if (this.state.loading)
      return (<div className="site-page-panel">Loading...</div>);

    let divs = [];
    for (let i = 0; i < this.state.posts.length; i++) {
      let post = this.state.posts[i];
      let repost = null;
      if(post.repost) {
        repost = post.author;
        post = post.repost;
      }

      divs.push(
        <ContentPanel 
          key={i}
          author={post.author}
          date={post.date}
          content={post.content}
          reply={true}
          repost={repost}
          onClick={()=>this.onPostClick(post.id)}
        >
          <ActivityButtons 
            reposts={post.reposts} 
            reposted={post.reposted} 
            likes={post.likes} 
            liked={post.liked} 
            post={post} 
            reply={true} 
          />
        </ContentPanel>
      )
    }
      // divs.push(<ActivityPost key={i} data={this.state.posts[i]} />);

    return divs.length > 0 ? divs : <div className="site-page-panel">No posts yet.</div>
  }

  renderBlogs() {
    if (this.state.loading)
      return (<div className="site-page-panel">Loading...</div>);

    let divs = [];
    for (let i = 0; i < this.state.blogs.length; i++)
      if(this.state.blogs[i].state == 'published')
        divs.push(<BlogCard key={i} data={this.state.blogs[i]}  onClick={this.onBlogClick} onEdit={this.onBlogEdit} />);

    return divs.length > 0 ? divs : <div className="site-page-panel">No blogs yet.</div>
  }

  render() {
    let parts = window.location.pathname.split('/');
    if(parts.length == 2 && !Server.account.isLoggedIn())
      return(<Navigate replace to="/" />);

    if(this.state.navigate != '') 
      return <Navigate to={this.state.navigate} />;

    if (this.state.profile == null) {
      return (
        <div className="site-page">
          <PageEnvelope width="600px">
            <div className="site-page-panel">
              {this.state.profileError == '' ?
                <div>Loading...</div> :
                <div>{this.state.profileError}</div>
              }
            </div>
          </PageEnvelope>
        </div>
      )
    }
      
    let joined = new Date(this.state.profile.joined).toLocaleDateString();
    let isFriend    = Server.account.isLoggedIn() && Server.user.isFriend(this.state.profile.id);
    let isCurrent   = Server.account.isLoggedIn() && Server.user.isCurrent(this.state.profile.id);
    
    return (
      <div className="site-page">
        <PageEnvelope width="600px">
          <div className="site-page-column">

            <div className="site-page-column" style={{rowGap: '0px'}}>
              <div className="site-page-row" style={{position: 'relative'}}>
                <img className="site-portrait-banner" src={getBannerImage(this.state.profile)} />
                <img 
                  className="site-page-portrait" 
                  style={{
                    position: 'absolute', 
                    bottom: '0px', 
                    left: '10px',
                    transform: 'translateY(45%)',
                    width: '80px',
                    height: '80px'
                  }} 
                  src={getPortraitImage(this.state.profile)} 
                />
              </div>

              <div className="site-page-panel" style={{padding: '15px', borderTopLeftRadius: '0px', borderTopRightRadius: '0px'}}>
                <div style={{marginTop: '-5px', marginRight: '-5px'}}>
                  {this.renderActionButtons()}
                </div>

                <div className="site-page-row" style={{alignItems: 'normal', marginTop: '-10px'}}>
                  <div className="site-page-title-text">{this.state.profile.name}</div>
                  <div className="site-page-subtext">@{this.state.profile.slug}</div>
                </div>

                {this.state.profile.bio && 
                  <div>{this.state.profile.bio}</div>
                }

                <div className="site-page-row" style={{marginTop: '5px'}}>
                  <BsCalendarWeek />
                  <div className="site-page-subtext">Joined {joined}</div>
                </div>


                {(isCurrent || isFriend) && 
                  <div className="site-page-row site-page-subtext" style={{marginTop: '5px', columnGap: '15px'}}>
                    <NavLink to={`/profile/${this.state.profile.slug}/followers`}>
                      {this.state.profile.followers.length} Followers
                    </NavLink>
                    <NavLink to={`/profile/${this.state.profile.slug}/following`}>
                    {this.state.profile.following.length} Following
                    </NavLink>
                  </div>
                }
              </div>
            </div>

            <div className="site-page-column" style={{marginTop: '10px'}}>
              <div>
                <select
                  style={{width: '200px'}} 
                  value={this.state.filter} 
                  onChange={(e)=>this.onFilter(e.currentTarget.value)}
                >
                  <option value="activity">Activity Posts</option>
                  <option value="blogs">Published Blogs</option>
                </select>
              </div>

              {this.state.filter == 'activity' ? this.renderPosts() : this.renderBlogs()}

              {!this.state.loading && this.state.filter == 'activity'
                ? this.state.posts.length > 0 && this.renderLoadMoreButton()
                : this.state.blogs.length > 0 && this.renderLoadMoreButton()
              }
            </div>

          </div>
        </PageEnvelope>

        <EditProfileModal open={this.state.openEditProfile} onClose={this.onCloseEditProfile} />
        <MessageModal message={this.state.message} />
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
        <QuestionModal message={this.state.question} onYes={this.onQuestionYes} onNo={this.onQuestionNo} />
      </div>
    );
  }
}

export default ProfilePage;
